@if (component && edge) {
  <ion-card button
    [routerLink]="'/device/' + edge.id + newNavigationUrlSegment + '/history/' + component.id + '/delayedselltogridchart'"
    >
    <ion-item lines="full" color="light">
      <ion-icon slot="start" size="large" color="normal" name="trending-down-outline"></ion-icon>
      <ion-label>{{ component.alias }}</ion-label>
    </ion-item>
    <ion-card-content style="color: var(--ion-card-content-color);">
      <table class="full_width">
        <tr>
          <td style="width:35%" class="align_right">
            &nbsp;
          </td>
        </tr>
      </table>
    </ion-card-content>
  </ion-card>
}